import React from 'react';
import './MultiWellControlActions.scss';
import { ReactComponent as Signal } from '../../../images/signal-01.svg';
import { ReactComponent as PlayCircle } from '../../../images/play-circle.svg';
import { ReactComponent as StopCircle } from '../../../images/stop-circle.svg';
import { ReactComponent as ClearAlarm } from '../../../images/clear-alarm.svg';
import { ReactComponent as Refresh } from '../../../images/refresh-ccw-01.svg';
import useWellControlActions from '../useWellControlActions';
import { useToastService } from '../../../components/toast/ToastService';
import Helpers from '../../../utilities/Helpers';

export const wellActions = [
  { label: 'Scan', icon: Signal },
  { label: 'Start Asset', icon: PlayCircle },
  { label: 'Shutdown Asset', icon: StopCircle },
  { label: 'Clear Alarms', icon: ClearAlarm },
  { label: 'Reset clocks', icon: Refresh },
];

interface MultiWellControlActionsProps {
  selectedAssetIds: string[];
  onScanComplete?: (success: boolean, message?: string) => void;
  onActionSelected: (action: string) => void;
}

const MultiWellControlActions: React.FC<MultiWellControlActionsProps> = ({
  selectedAssetIds,
  onScanComplete,
  onActionSelected,
}) => {
  const { isLoading } = useWellControlActions(selectedAssetIds, onScanComplete);
  const { showErrorToast } = useToastService();

  const handleActionClick = (actionLabel: string) => {
    if (selectedAssetIds.length === 0) {
      showErrorToast('Selection Required', 'Please select at least one well to perform this action');
      return;
    }

    onActionSelected(actionLabel);
  };

  return (
    <div className='well-control-actions'>
      <div className='well-control-actions__header'>Well control actions</div>
      {wellActions.map((action, idx) => (
        <div
          key={idx}
          className={`well-control-actions__item ${isLoading && action.label === 'Scan' ? 'Scanning' : ''}`}
          onClick={() => handleActionClick(action.label)}
          style={{ cursor: 'pointer' }}
        >
          <action.icon className='well-control-actions__icon' style={{ stroke: '#fffff' }} />
          <span className='well-control-actions__label'>{Helpers.toSentenceCase(action.label)}</span>
        </div>
      ))}
    </div>
  );
};

export type { MultiWellControlActionsProps };
export default MultiWellControlActions;
